import React from "react";
import Link from "gatsby-link";
import PropTypes from "prop-types";
import Menu from "react-burger-menu/lib/menus/slide";
import SocialIcons from "../SocialIcons/index.jsx";

import { rhythm } from "../../utils/typography";

import "./header.css";
import "./burger.css";

const ListLink = props => <li>
    <Link to={props.to}>{props.children}</Link>
  </li>;

ListLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired
};

// eslint-disable-next-line one-var
// Const Header = ({ title, hideGuides }) => <header>
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menuOpen: false };
  }

  /*
   * This keeps your state in sync with the opening/closing of the menu
   * via the default means, e.g. clicking the X, pressing the ESC key etc.
   */
  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen });
  }

  // This can be used to close the menu, e.g. when a user clicks a menu item
  closeMenu() {
    this.setState({ menuOpen: false });
  }

  /*
   * This can be used to toggle the menu, e.g. when using a custom icon
   * Tip: You probably want to hide either/both default icons if using a custom icon
   * See https://github.com/negomi/react-burger-menu#custom-icons
   */
  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
  }

  render() {
    const { hideGuides, social } = this.props;

    return (
      <header className="header" style={{ paddingTop: rhythm(2) }}>
        <span className="mobileNav">
          <Menu
            right
            isOpen={this.state.menuOpen}
            onStateChange={state => this.handleStateChange(state)}
          >
            <li>
              <Link onClick={() => this.closeMenu()} to="/">
                Blog
              </Link>
            </li>
            {hideGuides ||
              <li>
                <Link onClick={() => this.closeMenu()} to="/guides">
                  Guides
                </Link>
              </li>
            }
            <li>
              <Link onClick={() => this.closeMenu()} to="/training">
                Training
              </Link>
            </li>
            <li>
              <Link onClick={() => this.closeMenu()} to="/about">
                About
              </Link>
            </li>
          </Menu>
        </span>
        <div className="container">
          <h1
            style={{
              lineHeight: rhythm(2),
              fontSize: rhythm(1.5)
            }}
          >
            <Link to="/">Andrew Griffiths</Link>
          </h1>
          <nav className="desktopNav">
            <ul className="links" style={{ lineHeight: rhythm(1.5) }}>
              <ListLink to="/">Blog</ListLink>
              {hideGuides || <ListLink to="/guides">Guides</ListLink>}
              <ListLink to="/about">About</ListLink>
              <ListLink to="/training">Training</ListLink>
            </ul>
            <SocialIcons social={social} />
          </nav>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  hideGuides: PropTypes.bool,
  title: PropTypes.string.isRequired,
  social: PropTypes.shape({
    twitter: PropTypes.string.isRequired,
    linkedin: PropTypes.string.isRequired,
    github: PropTypes.string.isRequired
  })
};
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx